import React, { useState } from 'react';
import { motion } from 'framer-motion';

interface FlashCardProps {
  question: string;
  answer: string;
  category: string;
}

export function FlashCard({ question, answer, category }: FlashCardProps) {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div
      className="relative w-full h-64 cursor-pointer"
      onClick={() => setIsFlipped(!isFlipped)}
      style={{ perspective: '1000px' }}
    >
      <motion.div
        className="w-full h-full relative"
        animate={{ rotateY: isFlipped ? 180 : 0 }}
        transition={{ duration: 0.6 }}
        style={{ transformStyle: 'preserve-3d' }}
      >
        <div
          className={`absolute w-full h-full backface-hidden bg-white rounded-xl shadow-lg p-6 ${
            isFlipped ? 'hidden' : ''
          }`}
        >
          <div className="h-full flex flex-col">
            <div className="text-sm text-blue-500 mb-2">{category}</div>
            <div className="flex-1 flex items-center justify-center text-center">
              <div className="text-lg font-medium">{question}</div>
            </div>
            <div className="text-sm text-gray-400 text-center mt-4">
              Click to reveal answer
            </div>
          </div>
        </div>

        <div
          className={`absolute w-full h-full backface-hidden bg-white rounded-xl shadow-lg p-6 ${
            !isFlipped ? 'hidden' : ''
          }`}
          style={{ transform: 'rotateY(180deg)' }}
        >
          <div className="h-full flex flex-col">
            <div className="text-sm text-green-500 mb-2">{category}</div>
            <div className="flex-1 flex items-center justify-center text-center">
              <div className="text-lg">{answer}</div>
            </div>
            <div className="text-sm text-gray-400 text-center mt-4">
              Click to see question
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}